import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";

import smile1 from "../../assets/img/smiles/1.jpeg";
import smile2 from "../../assets/img/smiles/2.jpeg";
import smile3 from "../../assets/img/smiles/3.jpeg";
import smile4 from "../../assets/img/smiles/4.jpeg";
import smile5 from "../../assets/img/smiles/5.jpeg";

const Gallery = () => {
  const [isVisible, setIsVisible] = useState(false);
  const swiperRef = useRef(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  return (
    <div className="container-fluid p-4 w-100" style={{ height: "100%" }}>
      <div className="d-flex flex-column align-items-center">
        <h2
          className={`text-center fs-700 fs-40 ${
            isVisible
              ? "animate__animated animate__slideInLeft"
              : "animate__animated animate__fadeOut"
          }`}
        >
          Just a few of the <span className="text-golden">happy</span>
          <br /> <span className="text-golden">patients </span> we’ve treated
        </h2>
        <p className="fs-17 w-75 text-center mt-2">
        Imagine what composite bonding could do for your smile. Join millions of other patients worldwide who have perfected their smiles with composite bonding!
        </p>

        {/* Swiper component with border */}
        <div className=" container  w-100">
          <Swiper
            ref={swiperRef}
            spaceBetween={10}
            slidesPerView={1}
            loop={true}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            modules={[Navigation]}
            className="mt-4"
          >
            <SwiperSlide>
              <div className="image-container">
                <img src={smile1} alt="Patient 1" className="img-fluid w-100" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-container">
                <img src={smile2} alt="Patient 1" className="img-fluid w-100" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-container">
                <img src={smile3} alt="Patient 1" className="img-fluid w-100" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-container">
                <img src={smile4} alt="Patient 1" className="img-fluid w-100" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-container">
                <img src={smile5} alt="Patient 1" className="img-fluid w-100" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        {/* Custom Navigation Buttons with border */}
        <div className="d-flex justify-content-center w-100 p-2 mt-4">
          <button
            onClick={goPrev}
            className="btn btn-outline-theme p-3 me-3 navigation-btn"
          >
            <i className="fa fa-chevron-left"></i>
          </button>
          <button
            onClick={goNext}
            className="btn btn-outline-theme p-3 navigation-btn"
          >
            <i className="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
